module.exports = __webpack_public_path__ + "assets/img/ButtonDirect.69cba3bd.png";